import React from "react";
import { connect } from "react-redux";
import { Bets } from "../../../";
import { loadAllBetTypes } from "../../../../redux/actions/sportEventsActions";
import { setPropsMath } from "../../../../redux/actions/appActions";
import Timer from "../Timer";
import TeamName from "../TeamName";
import { Enums } from '../../../../helpers';
import { CountryCodes, AppConfig, SessionStorage } from "../../../../helpers";

import { Tabs } from "antd";

import DrillDownDetails from "./DrillDownDetails";
import { GetCustomBetOddFieldData } from "../../../../redux/actions/singnalrActions";

const TabPane = Tabs.TabPane;

class DrillDown extends React.Component {
  // selectedGroup=  is when navigating from notifications
  state = {
    isFrameLoading: true,
    selectedTab: window.location.search.includes("selectedGroup=")
      ? window.location.search.split("selectedGroup=")[1]
      : null,
  };

  async componentDidMount() {
    const { match, setPropsMath, loadAllBetTypes, connected } = this.props;
    window.scrollTo(0, 0);
    setPropsMath(match);
    if (connected) {
      const request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          EventId: Number(match.params.eventId),
        },
      };
      loadAllBetTypes(request);
    }
  }
  componentWillMount() {
    window.addEventListener("message", this.handleMessage);
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage);
  }

  async componentDidUpdate(prevProps) {
    const { match, setPropsMath, loadAllBetTypes, connected } = this.props;
    setPropsMath(match);

    if (
      prevProps.match.params.eventId !== this.props.match.params.eventId ||
      (!prevProps.connected && connected)
    ) {
      const request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          EventId: Number(match.params.eventId),
        },
      };
      loadAllBetTypes(request);
    }
  }
  handleMessage = (event) => {
    // Check if the message is from the expected iframe source
    // Log the event object for debugging
    const { GetCustomBetOddFieldData, match } = this.props;

    console.log("Received message from iframe:", event.data);
    if (event.data && event.data.type === "custom-bet") {
      console.log("Received console message from iframe:", event.data.message);
      let request = [];
      if (
        event.data.message &&
        event.data.message.selectedOutcomes &&
        event.data.message.displayedOdds
      ) {
        event.data.message.selectedOutcomes.map((outcome) => {
          request.push({
            eventId: Number(match.params.eventId),
            feed: { FeedId: Number(match.params.feed) },
            sport: { SportId: Number(match.params.sport) },
            outcomeId: outcome.outcomeId,
            uofId: Number(outcome.srMarket.id),
            specifiers: outcome.srMarket.specifiers,
          });
        });
        console.log(
          "Number(event.data.message.displayedOdds).toFixed(2)",
          Number(event.data.message.displayedOdds)
        );
        // updateCustomBetDisplayOdd(Number(event.data.message.displayedOdds).toFixed(2))
        SessionStorage.betBuilderDisplayOdds = Number(
          event.data.message.displayedOdds
        );
        GetCustomBetOddFieldData(request);
      }
    }
  };
  onTabChange(key) {
    this.setState({ selectedTab: key , isFrameLoading:true });
  }
  // getCountryCode = (name) => {
  //   let result =
  //   this.props.countryFlags &&
  //   this.props.countryFlags.filter((element) => {
  //     return element.countryName.toLowerCase() == name.toLowerCase();
  //   });
  // if (result && result.length > 0) {
  //   return result[0].countryFlagImagesName;
  // }
  // };
  checkImage = (teamId) => {
    this.setState({
      [teamId]: true,
    });
  };
  frameLoad = (value) => {
    this.setState({
      isFrameLoading: value,
    });
  };

  render() {
    const {
      eventData,
      groupsIds,
      error,
      drillDownTabs,
      customBetFilePath,
      customBetSports,
      isDark,
      customBetData,
      showNewIcon,
      newIconImage,
    } = this.props;
    drillDownTabs &&
      drillDownTabs.length > 0 &&
      !drillDownTabs.includes("Bet Builder") &&
      drillDownTabs.splice(1, 0, "Bet Builder");
    let showCustomBet;
    showCustomBet =
      customBetSports &&
      customBetSports.filter((item) => {
        return (
          item.feedId == Number(this.props.match.params.feed) &&
          item.sportId == Number(this.props.match.params.sport)
        );
      });
    return (
      <div className="dd">
        {/* <DrillDownDetails {...this.props} data={eventData}></DrillDownDetails> */}

        {error && (
          <div className="groups">
            <div>{error}</div>
          </div>
        )}
        {eventData && (
          <div id="single-match-top-container">
            <div className="single-match-top-container-header">
              <div>
                {eventData.feed.feedId == 5 && (
                  <>
                    <div>{`${eventData.eventStatus &&
                      eventData.eventStatus.eventStatusDisplayName}`}</div>
                    {eventData.eventScore && (
                      <Timer type="up" time={eventData.eventScore.eventTime} />
                    )}
                  </>
                )}
              </div>

              <div>
                <img
                  style={{
                    width: "25px",
                    height: "15px",
                    marginRight: "4px",
                  }}
                  src={
                    AppConfig.countryFlagImagesPath +
                    (eventData.eventCategory.categoryFlagCode
                      ? eventData.eventCategory.categoryFlagCode
                      : `eu`) +
                    `.webp`
                  }
                  alt="country-flag"
                />
                &nbsp;
                <span>{eventData.eventCategory.categoryDisplayName}</span>
                <span style={{ opacity: "0.5" }}>
                  /{eventData.eventTournament.tournamentDisplayName}
                </span>
              </div>
              <div>
                <span
                  style={{ opacity: "0.5" }}
                >{`ID: ${eventData.eventBetLineNo}`}</span>
              </div>
            </div>

            <hr />
            <div className="single-match-top-container-footer">
              <div className="team-container">
                {!this.state[eventData.eventHomeTeamId] && (
                  <div>
                    <img
                      src={`${AppConfig.teamsIconPath}${eventData.eventHomeTeamId}_b.webp`}
                      alt="leagues-icon"
                      onError={() => this.checkImage(eventData.eventHomeTeamId)}
                      height={"34px"}
                      width={"34px"}
                    />
                  </div>
                )}
                {this.state[eventData.eventHomeTeamId] &&
                eventData.eventHomeTeamName.split(" ").length >= 2 ? (
                  <div
                    style={
                      eventData.eventHomeTeamColor &&
                      eventData.eventHomeTeamColor != "ffffff"
                        ? {
                            backgroundColor: `#${eventData.eventHomeTeamColor}`,
                          }
                        : { backgroundColor: "#AEB4BF" }
                    }
                    className="topbets-alternative-image"
                  >
                    {" "}
                    <span>{eventData.eventHomeTeamName.split(" ")[0][0]}</span>
                    <span>{eventData.eventHomeTeamName.split(" ")[1][0]}</span>
                  </div>
                ) : this.state[eventData.eventHomeTeamId] &&
                  eventData.eventHomeTeamName.split(" ").length == 1 ? (
                  <div
                    style={
                      eventData.eventHomeTeamColor &&
                      eventData.eventHomeTeamColor != "ffffff"
                        ? {
                            backgroundColor: `#${eventData.eventHomeTeamColor}`,
                          }
                        : { backgroundColor: "#AEB4BF" }
                    }
                    className="topbets-alternative-image"
                  >
                    {" "}
                    <span>{eventData.eventHomeTeamName.split(" ")[0][0]}</span>
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <TeamName name={eventData.eventHomeTeamName} />
                </div>
              </div>
              <div className="date-container">
                {(eventData.feed.feedId == 5 && eventData.eventScore && eventData.eventScore.score) ? (
                  <p style={{ opacity: "0.5", marginBottom: "0px" }}>
                    {eventData.eventScore.score.split(":")[0]}:
                    {eventData.eventScore.score.split(":")[1]}
                  </p>
                ) : (
                  <p style={{ opacity: "0.5", marginBottom: "0px" }}>
                    {eventData.eventDateOfMatchFormated}
                  </p>
                )}
              </div>

              <div className="team-container">
                {!this.state[eventData.eventAwayTeamId] && (
                  <div className="row-1">
                    {" "}
                    <img
                      src={`${AppConfig.teamsIconPath}${eventData.eventAwayTeamId}_b.webp`}
                      alt="leagues-icon"
                      onError={() => this.checkImage(eventData.eventAwayTeamId)}
                      height={"34px"}
                      width={"34px"}
                    />
                  </div>
                )}
                {this.state[eventData.eventAwayTeamId] &&
                eventData.eventAwayTeamName.split(" ").length >= 2 ? (
                  <div
                    style={
                      eventData.eventAwayTeamColor &&
                      eventData.eventAwayTeamColor != "ffffff"
                        ? {
                            backgroundColor: `#${eventData.eventAwayTeamColor}`,
                          }
                        : { backgroundColor: "#AEB4BF" }
                    }
                    className="topbets-alternative-image"
                  >
                    {" "}
                    <span>{eventData.eventAwayTeamName.split(" ")[0][0]}</span>
                    <span>{eventData.eventAwayTeamName.split(" ")[1][0]}</span>
                  </div>
                ) : this.state[eventData.eventAwayTeamId] &&
                  eventData.eventAwayTeamName.split(" ").length == 1 ? (
                  <div
                    style={
                      eventData.eventAwayTeamColor &&
                      eventData.eventAwayTeamColor != "ffffff"
                        ? {
                            backgroundColor: `#${eventData.eventAwayTeamColor}`,
                          }
                        : { backgroundColor: "#AEB4BF" }
                    }
                    className="topbets-alternative-image"
                  >
                    {" "}
                    <span>{eventData.eventAwayTeamName.split(" ")[0][0]}</span>
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <TeamName name={eventData.eventAwayTeamName} />
                </div>{" "}
              </div>
            </div>
          </div>
        )}
        {drillDownTabs && (
          <Tabs
            className="tabs-events"
            defaultActiveKey={this.state.selectedTab || drillDownTabs[0]}
            activeKey={this.state.selectedTab || drillDownTabs[0]}
            onChange={(key) => {
              this.onTabChange(key);
            }}
          >
            {drillDownTabs.map((item, i) =>
              i == 1 && showCustomBet && showCustomBet.length > 0 ? (
                <TabPane
                  tab={
                    <div className="new-icon-container">
                      Bet Builder
                      {showNewIcon && (
                        <img
                          src={newIconImage}
                          alt="new-icon"
                          className="new-icon"
                        />
                      )}
                    </div>
                  }
                  key={item}
                />
              ) :i == 1 && showCustomBet && showCustomBet.length == 0 ? null : (
                <TabPane tab={item} key={item} />
              )
            )}
          </Tabs>
        )}

        {groupsIds && groupsIds.length == 0 && (
          <div className="lds-parent-ring">
            <div class="lds-ring">
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        )}

        {eventData && eventData.feed && groupsIds && drillDownTabs && (
          <div className="groups">
            {this.state.selectedTab == "Bet Builder" &&
              customBetFilePath &&
              showCustomBet &&
              showCustomBet.length > 0 && (
                <>
                  {this.state.isFrameLoading && (
                    <div className="events">
                      <div className="lds-parent-ring">
                        <div class="lds-ring">
                          <div />
                          <div />
                          <div />
                          <div />
                        </div>
                      </div>
                    </div>
                  )}
                  <iframe
                    onLoad={(e) => this.frameLoad(false)}
                    style={{ width: "100%", height: "550px" }}
                    key={`${customBetFilePath}?matchId=${eventData.eventId}}&isDarkTheme=${isDark}`}
                    title="custom-bet"
                    frameBorder="0"
                    src={`${customBetFilePath}?matchId=${eventData.eventId}&isDarkTheme=${isDark}`}
                  />
                </>
              )}
            {groupsIds.map((id) => (
              <Bets.EventOddGroup
                fromDrillDown={true}
                eventEnabled={eventData.enableBet}
                key={id}
                groupId={id}
                eventId={eventData.key}
                selectedTab={this.state.selectedTab || drillDownTabs[0]}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    eventData: state.sportEvents.eventData,
    groupsIds: state.sportEvents.eventOddGroupIds,
    error: state.sportEvents.error,
    drillDownTabs: state.sportEvents.drillDownTabs,
    feedName: state.app.feedName,
    countryFlags: state.general.countryFlags,
    connected: state.app.feedId == Enums.Feed.Static ?
			state.signalr.staticConnected :
				state.app.feedId == Enums.Feed.Live ?
				state.signalr.liveConnected :
				state.signalr.virtualConnected,
    customBetFilePath: state.general.configuration.customBetFilePath,
    customBetSports: state.general.configuration.customBetSports,
    isDark: state.app.isDark,
    customBetData: state.betSlip.customBetData,
    newIconImage: state.general.configuration.newIconImage,
    showNewIcon: state.general.configuration.showNewIcon,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    loadAllBetTypes: (request) => {
      dispatch(loadAllBetTypes(request));
    },
    setPropsMath: (match) => {
      dispatch(setPropsMath(match));
    },
    GetCustomBetOddFieldData: (request) => {
      dispatch(GetCustomBetOddFieldData(request));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrillDown);
